export enum OfficePropertyDetailMenuEnum {
  overview = 11,
  unitRental,
  propertyTransaction,
  officeRentUnitSizeWise,
  retailRentUnitSizeWise
}
